import type { Category as CategoryType } from '@subaio/api-types/budget'
import { ChevronFlip } from '@subaio/components'

import { Cell, ItemExpandable } from 'components/Lists'

import { Amount } from '../Amount'
import { EmptyChevron } from '../EmptyChevron'
import { Subcategory } from '../Subcategory'
import { HeaderRow } from './HeaderRow'

type Props = {
	id: string
	name: string

	categories: Array<CategoryType>
	currency: string
	fieldsBeingSubmitted: Array<string>
	totalMonthlyAmount: number
	totalMonthlyAmountUserProvided: number | null
}

export const Category = ({
	id,
	name,
	currency = 'DKK',
	totalMonthlyAmount,
	totalMonthlyAmountUserProvided,
	categories,
	fieldsBeingSubmitted,
}: Props) => {
	const hasCategories = categories && categories.length > 0

	return (
		<ItemExpandable
			renderRow={({ isExpanded, ...rest }) => (
				<HeaderRow {...rest}>
					<Cell textAlign='center'>{hasCategories ? <ChevronFlip isActive={isExpanded} /> : <EmptyChevron />}</Cell>
					<Cell shouldExpand>{name}</Cell>
					<Cell>
						<Amount
							amount={totalMonthlyAmount}
							currency={currency}
							userProvidedAmount={totalMonthlyAmountUserProvided}
							placeholderWidth='60px'
							isLoading={fieldsBeingSubmitted.some((categoryId) => categoryId.includes(id))}
						/>
					</Cell>
				</HeaderRow>
			)}
			isDisabled={!hasCategories}
		>
			{categories.map((category, index) => (
				<Subcategory key={index} fieldsBeingSubmitted={fieldsBeingSubmitted} {...category} />
			))}
		</ItemExpandable>
	)
}
